/* eslint-disable no-template-curly-in-string */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Row, Col, Card, Form, Input, DatePicker, Space, Button, Switch, InputNumber, Modal } from 'antd';
import PageTitle from 'shared_components/page_title';
import { SaveOutlined, RollbackOutlined, UserOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Avatar } from 'antd';
import { formatPhoneNumber, formatMobileNumber, formatValueOnChange } from 'utils/helper';
import Message from 'shared_components/message';

import { fetchAgentCodeAPI, createAgentAPI, updateAgentAPI } from 'services/agents/agents';
import moment from 'moment';
import { UserAccessContext } from 'context/userAccess';

export default function AddAgent(props) {
    const { userAccess } = useContext(UserAccessContext);
    const agentDetProps = (props.agentDetails === 'undefined' ? '' : props.agentDetails);
    const navigate = useHistory();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [allDisabled, setAllDisabled] = useState(false)

    const updateRight = userAccess['agents'].update;

    useEffect(()=> {
        if(props.isEditting){
            if(updateRight === 'TRUE'){
                setAllDisabled(false)
            }else{
                setAllDisabled(true)
            }
        }
    }, [agentDetProps])

    //get agent code
    async function getAgentCode(){
        try {
            const response = await fetchAgentCodeAPI()
            const code = response[0].agent_code;

            form.setFieldsValue({agent_code: code});

        }catch(error) {
            console.log("error", error)
        }
    }

    useEffect(()=> {
        if(!props.isEditting){
            getAgentCode();
        }
        
    }, []);

    //handle onchange input of tel_no
    const telNoInput = (e) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        console.table(formattedPhoneNumber);
        form.setFieldsValue({tel_no: formattedPhoneNumber});
    };

    const mobileNoInput = (e) => {
        const formattedMobileNumber = formatMobileNumber(e.target.value);
        form.setFieldsValue({mobile_no: formattedMobileNumber});
    };

    const commInput = (e) => {
        const formattedCommVal = formatValueOnChange(e.target.value, 'decimalonly');
        form.setFieldsValue({comm_rate: formattedCommVal});
    };

    const statusOnChange = (checked)=>{
        console.log("status", checked);
    };

    const validateMessages = {
        required: 'Required Field',
        // types: {
        //     email: '${label} IS NOT A VALID EMAIL.',
        // },
    };

    const disabledDate = (current) => {
        // Can not select future dates
        return current > moment().endOf('day');
    };

    function handleSubmit(formValues){
        // call modal
        Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure you want to continue?',
            okText: 'YES',
            cancelText: 'NO',
            onOk: ()=>{
                handleConfirm(formValues);
            }
        });
    };
    
    async function handleConfirm(formValues) {
        const payload = {
                ...formValues,
                //ACD Fixed error on saving blank string for comm rate data type numeric
                comm_rate: (formValues.comm_rate === "" ? 0.00 : formValues.comm_rate)
        }

        if(!props.isEditting){
            try {
                const response = await createAgentAPI(payload);
                // @ts-ignore
                if(response.data.agent_code !== undefined){
                    Message.success({ message: 'You have successfully added agent.' });
        
                    navigate.push('/agent/search');
                }else{
                    // @ts-ignore
                    const res = response.data;
                    const resData = res.includes('duplicate key') && res.includes('agents_idx2');

                    if(resData){
                        Message.error({ message: 'Agent is already existing.' });
                    }else{
                        Message.error({ message: res });
                    }
                }
                
            }catch(error) {
                console.log("error", error)
                Message.error();
            }
        }else{
            try {
                const response = await updateAgentAPI(payload);
                Message.success({ message: 'You have successfully updated agent.' });

                navigate.push('/agent/search');
            }catch(error) {
                console.log("error", error)
                Message.error();
            }
        }
    };

    function handleBack(){
        // call modal
        Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: 'Are you sure you want to cancel? All unsaved details will be discarded.',
            okText: 'YES',
            cancelText: 'NO',
            onOk: ()=>{ navigate.push('/agent/search') }
        });
    };

    return(
        <div id='add_agents'>
            <Card style={{ padding:"0 80px 0 80px" }}>
                <PageTitle pageTitle="AGENT DETAILS" />
                <Form layout='vertical'
                    validateMessages={validateMessages}
                    onFinish={handleSubmit}
                    form={form}
                >
                    <Row gutter={[8, 1]} justify='end'>
                    <Col>
                        <Form.Item name="status"
                            initialValue={(props.isEditting) ? agentDetProps.is_active : true}
                        >
                            <Switch 
                                checkedChildren='Active' 
                                unCheckedChildren='Inactive' 
                                onChange={statusOnChange}
                                defaultChecked={(props.isEditting) ? agentDetProps.is_active : true}
                                disabled={allDisabled}
                            />
                        </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[8, 1]} align='top'>
                        <Col span={7}>
                            {/* avatar */}
                            <div style={{ float:'left' }}>
                                <Avatar 
                                    shape="square" 
                                    size={200} 
                                    icon={<UserOutlined />} 
                                    style={{ marginTop:20 }}
                                />
                            </div>
                        </Col>
                        <Col span={17}>
                            {/* user details */}
                            <Row gutter={[8, 1]}>
                                <Col span={8}>
                                    <Form.Item
                                        label='AGENT CODE'
                                        name="agent_code"
                                        initialValue={(props.isEditting) ? agentDetProps.agent_code : ''}
                                    >
                                        <Input 
                                            placeholder='AGENT CODE'
                                            disabled
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='COMMISSION RATE'
                                        name="comm_rate"
                                        // rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.commission_rate : ''}
                                    >
                                        <Input
                                            placeholder = '0'
                                            maxLength={7}
                                            addonAfter="%"
                                            onChange={commInput}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='DATE HIRED'
                                        name="date_hired"
                                        // rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? (agentDetProps.date_hired === null ? null : moment(agentDetProps.date_hired)) : ''}
                                    >
                                        {/* @ts-ignore */}
                                        <DatePicker format={"MM-DD-YYYY"} style={{ width:'100%' }} disabledDate={disabledDate} disabled={allDisabled} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8, 1]}>
                                <Col span={8}>
                                    <Form.Item
                                        label='LAST NAME'
                                        name="last_name"
                                        rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.last_name : ''}
                                    >
                                        <Input 
                                            className='inv-input-uppercase'
                                            type={'text'} 
                                            placeholder='LAST NAME'
                                            maxLength={50}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='FIRST NAME'
                                        name="first_name"
                                        rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.first_name : ''}
                                    >
                                        <Input 
                                            className='inv-input-uppercase'
                                            type={'text'}
                                            placeholder='LAST NAME' 
                                            maxLength={50}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='MIDDLE NAME'
                                        name="middle_name"
                                        // rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.middle_name : ''}
                                    >
                                        <Input 
                                            className='inv-input-uppercase'
                                            type={'text'}
                                            placeholder='MIDDLE NAME' 
                                            maxLength={50}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8, 1]}>
                                <Col span={24}>
                                    <Form.Item
                                        label='ADDRESS'
                                        name="address"
                                        // rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.address : ''}
                                    >
                                        <Input type={'text'}
                                            className='inv-input-uppercase'
                                            placeholder='ADDRESS' 
                                            maxLength={200}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={[8, 1]}>
                                <Col span={8}>
                                    <Form.Item
                                        label='TEL. NO.'
                                        name="tel_no"
                                        initialValue={(props.isEditting) ? agentDetProps.tel_no : ''}
                                    >
                                        <Input 
                                            placeholder='(632)XXXX-YYYY'
                                            onChange={telNoInput}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='MOBILE NO.'
                                        name="mobile_no"
                                        // rules={[ {required: true} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.mobile_no : ''}
                                    >
                                        <Input 
                                            placeholder='(639)XX-XXX-YYYY'
                                            onChange={mobileNoInput}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <Form.Item
                                        label='EMAIL ADDRESS'
                                        name="email_address"
                                        rules={[ {type: 'email'} ]}
                                        initialValue={(props.isEditting) ? agentDetProps.email_address : ''}
                                    >
                                        <Input 
                                            className='inv-input-uppercase'
                                            placeholder='EMAIL ADDRESS'
                                            maxLength={50}
                                            disabled={allDisabled}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/* buttons */}
                    <Row gutter={[8, 1]} justify='end'>
                        <Col style={{marginTop:50}}>
                            <Form.Item>                                
                                <Button 
                                    className="inv-button-right" 
                                    type="primary" 
                                    onClick={handleBack}
                                    icon={<RollbackOutlined />}
                                >
                                    BACK
                                </Button>
                                <Button 
                                    className="inv-button" 
                                    type="primary" 
                                    htmlType='submit'
                                    icon={<SaveOutlined />}
                                    disabled={allDisabled}
                                >
                                    SAVE
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
}